import { AnalyticsBrowser } from '@segment/analytics-next';
import { string as zString } from 'zod';

const PUBLIC_SEGMENT_KEY = zString().parse(process.env.PUBLIC_SEGMENT_KEY);

// For the "track" function, the standard the team agreed upon for event names is
// Title Case (spacing allowed)
export const analytics = AnalyticsBrowser.load({
  writeKey: PUBLIC_SEGMENT_KEY,
});
